/* eslint-disable no-console */
import { development } from './env'

const noop = () => {}

export const dev = development ? console.log : noop
export const { info, warn, error } = console
